import React, { Fragment, ReactElement } from 'react';
import Card from '../../../../components/card/card.component';
import Tooltip from '../../../../components/tooltip/tooltip.component';
import ActionButton from '../../../../components/action-button/action-button.component';
import FlexContainer from '../../../../components/flex-container/flex-container.component';
import ExpansionGroup from '../../../../components/expansion-group/expansion-group.component';
import NoContentBlock from '../../../../components/no-content-block/no-content-block.component';
import Widget from '../../../../components/widget/widget.component';
import ActionButtonContainer from '../../../../components/action-button-container/action-button-container.component';
import ActionButtonNewItem from '../../../../components/action-button-new-item/action-button-new-item.component';
import FormFieldText from '../../../../components/form-field-text/form-field-text.component';
import SinglePageTab from '../../../app/common/single-page-tab/single-page-tab.component';
import RemoveIcon from '../../../../icons/remove-icon';
import FormService from '../../../../services/form-service';

const DealTemplateDealFiles: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSaving,
    isSaveDisabled,
    isEditMode,
    isActive,
    isRightDrawerOpen,
    formError,
    dealTemplateInitialData,
    onCancelForm,
    onSubmitForm,
    onDealFileGroupAdd,
    onDealFileGroupDelete,
  } = props;

  const initialDataFormPrefix: string = 'initialData';
  const dealTemplateInitialDataDealFileGroups: DealFileGroup[] = (dealTemplateInitialData
    && dealTemplateInitialData.dealFileGroups) || [];

  return (
    <SinglePageTab
      isSaving={isSaving}
      isSaveDisabled={isSaveDisabled}
      isEditMode={isEditMode}
      isHidden={!isActive}
      isRightDrawerOpen={isRightDrawerOpen}
      formError={formError}
      onCancelForm={onCancelForm}
      onSubmitForm={onSubmitForm}
    >
      {
        ((dealTemplateInitialDataDealFileGroups && !!dealTemplateInitialDataDealFileGroups.length) || isEditMode) ? (
          <Widget isFullHeight isFullWidth defaultWidgetTitle="Deal File Groups">
            {
              dealTemplateInitialDataDealFileGroups.map((dealFileGroup: DealFileGroup): ReactElement => {
                const formKeyDealFileGroup: string = FormService.getIndexedFormFieldKey(dealFileGroup.id);

                return (
                  <ExpansionGroup
                    isFixed
                    isExpanded
                    isDefaultExpanded
                    key={dealFileGroup.id}
                    headerComponent={(
                      <FlexContainer isSpread>
                        <FlexContainer isSpread isStart>
                          {
                            !isEditMode && dealFileGroup.name
                          }
                          {
                            isEditMode && (
                              <Fragment>
                                <FormFieldText
                                  isHidden
                                  name={`${initialDataFormPrefix}.dealFileGroups[${formKeyDealFileGroup}].id`}
                                />
                                <FormFieldText
                                  isLight
                                  isLimited
                                  withUnderline
                                  placeholder="Name"
                                  name={`${initialDataFormPrefix}.dealFileGroups[${formKeyDealFileGroup}].name`}
                                />
                              </Fragment>
                            )
                          }
                        </FlexContainer>
                        {
                          isEditMode && (
                            <ActionButtonContainer>
                              <Tooltip title="Delete">
                                <ActionButton
                                  isLight
                                  withNoPadding
                                  onClick={(): void => {
                                    onDealFileGroupDelete(dealFileGroup.id);
                                  }}
                                >
                                  <RemoveIcon />
                                </ActionButton>
                              </Tooltip>
                            </ActionButtonContainer>
                          )
                        }
                      </FlexContainer>
                    )}
                  />
                );
              })
            }
            {
              isEditMode && (
                <Card
                  isDark
                  isContainer
                  isSelectable
                  withSmallPadding
                  onClick={onDealFileGroupAdd}
                >
                  <ActionButtonNewItem isLight withNoHighlight label="Add New Group" />
                </Card>
              )
            }
          </Widget>
        ) : (
          <NoContentBlock isExtended>
            No deal file groups
          </NoContentBlock>
        )
      }
    </SinglePageTab>
  );
});

export default DealTemplateDealFiles;
